export default __webpack_public_path__ + "images/bigship_favicon.svg";